<template>
  <div class="bg-primary text-white py-lg-8 py-5">
    <div class="container  text-center text-md-start">
      <div class="row">
        <div class="col-md-3  order-lg-last text-md-right">
          <img src="/images/balons/balon-line2.svg" alt="">
        </div>
        <div class="col-md-5 offset-lg-2">
          <div class="h2 fw-bold">
            Vuoi sapere di più su <br> Riforma in Movimento 2024?
          </div>
          <p class="text-white py-4 m-0">
            Se hai dubbi o curiosità sulla ricerca o se vuoi metterti in contatto con noi non esitare, scrivici!
          </p>
          <button class="btn btn-primary-light btn-cta" @click="openContactModal">Contattaci</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const { $event } = useNuxtApp();
const openContactModal = (action, value) => {
  $event('modal:contact', { action, value });
};
</script>